import React,{useState,useEffect} from 'react'
import { providerDetails } from '../../redux/provider/actions';
import { useDispatch,useSelector} from 'react-redux'
import _ from "lodash"
import Page from "../../components/Page"
import Loader from '../../components/Loader/Loader'
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import MenuCoaching from '../../components/MenuCoaching';
import BannerSectionProvider from '../../components/BannerSectionProvider';
import {
  SessionKeys,
} from "../../utils/AppUtils";
export default function ProviderDetailPage(props) {

    const location = useLocation();
    
    const { state } = location;
    const dispatch = useDispatch();
    const [providerDetailsData, setproviderDetailsData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    let providerId = params.get("provider_id");
    console.log("params",providerId);

  
  
      useEffect(() => {
        setIsLoading(true);
      dispatch(providerDetails({
            postData: {
                provider_id:providerId,
                entity_type:"get_provider_details",
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
         })
           )
      }, []);

      const providersDetailsResponse = useSelector((state)=>state.provider.providerDetailsRes);
      // console.log("provider detail in provider detail page",providersDetailsResponse)

      useEffect(() => {
        // console.log("respdata: provider details resp in provider details page",providersDetailsResponse);
        if (!_.isEmpty(providersDetailsResponse)) {
            if (providersDetailsResponse.status === "success") {
                setproviderDetailsData(providersDetailsResponse?.payload?.data);
                setIsLoading(false);
            } else {
                setproviderDetailsData();
                setIsLoading(false);
            }
            
        }
    }, [providersDetailsResponse]);
  

  return (
    <>
    <Loader start={isLoading} />
      <Page>
        <MenuCoaching providerId={providerId} selectedItem={0} showBanner={true} />
        <section class="container about-prouvder">
          <div class="row">
            <div class="col-md-12 main_realtor mt-5">
              <h6 class="pb-3">About <span dangerouslySetInnerHTML={{ __html: providerDetailsData?.provider_name }} /></h6>
              <div class="event-details-disc">
                <div dangerouslySetInnerHTML={{ __html: providerDetailsData?.description }} />
               </div>
              </div>
              </div>
          </section>
        
      </Page>
    </>
  )
}
